import _ from 'lodash'
import Constants from '@/utils/Constants'
import ApiManager from '../../utils/ApiManager'

const initialShopGroup = () => {
  return {
    id: null,
    name: '',
    tag: '',
    publish_setting: 0,
    conditions: '',
    details: [],
    shop_area_code: '',
    condition: {
      mode: 'group',
      group: [],
      category: [],
      code: [],
      name: [],
      file_name: '',
      freeword: null
    }
  }
}

const state = {

  loading: false,
  isSubmit: false,

  //  店舗初期データ
  constData: {
    shop_area: [],
    shop_group: [],
    shopCategoryLevel: 1,
    shop_category: []
  },
  //  site,contract,userデータ
  customData: {
    categoryRankName: [] //  カテゴリ階層名
  },
  shop_group: initialShopGroup(),
  //  店舗カート設定
  cartSettings: {
    labelName: 'name',
    keyName: 'shop_cd'
  },
  message: {
    content: '',
    type: ''
  }
}

const actions = {

  async init ({ commit }) {
    const param = {
      code: 'GR00006'
    }
    //  ページ初期データ読み込み
    const resConst = await ApiManager.request('Analyze').analyzeInit(param)
    //  ページデータcommit
    commit('setConstData', resConst.data.data)
    commit('setLoading', false)
  },
  //  店舗グループ決定
  async submitGroup ({ commit }, payload) {
    commit('setLoading', true)
    const param = {
      id: payload
    }
    //  カート店舗取得
    const res = await ApiManager.request('ShopSearch').shopSearchGroup(param)

    if (res && res.data && res.data.data && res.data.data.length > 0) {
      const data = {
        data: res.data.data
      }

      commit('setIsSubmit', true)
      commit('setCartItem', data)
      commit('setGroup', payload)
    }
    commit('setLoading', false)
  },
  /**
   * カテゴリーリストからカートに店舗を追加
   */
  async submitCategory ({ state, commit }, payload) {
    commit('setLoading', true)

    const param = {
      code: payload
    }
    //  商品コード利用
    let res = await ApiManager.request('ShopSearch').shopSearchCategory(param)

    if (res && res.data && res.data.data && res.data.data.length > 0) {
      const data = {
        data: res.data.data
      }

      commit('setIsSubmit', true)
      commit('setCartItem', data)
      commit('setCategory', payload)
    }
    commit('setLoading', false)
  },
  /**
   * 店舗コード決定からカートに店舗を追加
   * @param {object} payload
   */
  async submitCode ({ state, commit }, payload) {
    commit('setLoading', true)
    const param = {
      code: _.map(payload, c => {
        return {
          'shop_cd': c
        }
      })
    }
    let res = await ApiManager.request('ShopSearch').shopSearchCode(param)

    if (res && res.data && res.data.data && res.data.data.length > 0) {
      const data = {
        data: res.data.data
      }

      commit('setIsSubmit', true)
      commit('setCartItem', data)
      commit('setCode', payload)
    }
    commit('setLoading', false)
  },
  /**
   * 店舗名決定からカートに店舗を追加
   * @param { String } payload 店舗名
   */
  async submitName ({ state, commit }, payload) {
    commit('setLoading', true)
    const param = _.map(payload, c => {
      return {
        'name': c
      }
    })
    let res = await ApiManager.request('ShopSearch').shopSearchName(param)

    if (res && res.data && res.data.data && res.data.data.length > 0) {
      const data = {
        data: res.data.data
      }

      commit('setIsSubmit', true)
      commit('setCartItem', data)
      commit('setName', payload)
    }
    commit('setLoading', false)
  },
  /**
   * ファイルのアイテムリストからカートに店舗を追加
   * @param { Array } payload 店舗コード
   */
  async submitFile ({ state, commit }, payload) {
    commit('setLoading', true)
    const res = await ApiManager.request('ShopSearch').shopSearchFile(payload.file)

    if (res && res.data && res.data.data && res.data.data.length > 0) {
      const data = {
        data: res.data.data
      }

      commit('setIsSubmit', true)
      commit('setCartItem', data)
      commit('setFile', payload)
    } else {
      this.dispatch('routerdata/setApiMessage', res.data.data.message)
    }
    commit('setLoading', false)
  },
  //  フリーワード検索決定
  async submitFreeword ({ state, commit }, payload) {
    commit('setLoading', true)

    const param = {
      code: _.map(payload.data, c => {
        return {
          'shop_cd': c
        }
      })
    }
    let res = await ApiManager.request('ShopSearch').shopSearchCode(param)

    const data = {
      data: res.data.data
    }

    commit('addCartItem', data)
    commit('setFreeword', payload)
    commit('setLoading', false)
  },
  async detail ({ dispatch, state, commit }, id) {
    let type = 'success'
    const response = await ApiManager.request('ShopGroup').shopGroupDetail(id)
    if (response.data.code === Constants.ResponseCode.SUCCESS) {
      commit('setShopGroup', response.data)

      dispatch('setCondition', JSON.parse(response.data.data.conditions))
      return response.data.data
    } else if (response.data.code === Constants.ResponseCode.VALIDATE_ERROR) {
      type = 'error'
    }
    commit('setMessage', { content: response.data.data.message, type: type })
    return null
  },
  setCondition ({ state, commit, dispatch }, payload) {
    commit('setIsSubmit', false)
    const analyze = payload
    commit('setCondition', payload)
    let mode = analyze.mode
    if (mode === 'group') {
      if (analyze.group.length > 0) {
        // dispatch('submitGroup', analyze.group)
        commit('setIsSubmit', true)
        commit('setGroup', analyze.group)
      }
    } else if (mode === 'category') {
      if (analyze.category.length > 0) {
        // dispatch('submitCategory', analyze.category)
        commit('setIsSubmit', true)
        commit('setCategory', analyze.category)
      }
    } else if (mode === 'code') {
      if (analyze.code.length > 0) {
        // dispatch('submitCode', analyze.code)
        commit('setIsSubmit', true)
        commit('setCode', analyze.code)
      }
    } else if (mode === 'name') {
      if (analyze.name.length > 0) {
        // dispatch('submitName', analyze.name)
        commit('setIsSubmit', true)
        commit('setName', analyze.name)
      }
    } else if (mode === 'file') {
      if (analyze.file_name.length > 0) {
        // dispatch('submitFile', analyze.file_name)
        commit('setIsSubmit', true)
        commit('setFile', analyze.file_name)
      }
    }
  },
  async save ({ state, commit }, shopGroup) {
    commit('setLoading', true)
    let response = null
    shopGroup.conditions = JSON.stringify(state.shop_group.condition)
    if (shopGroup.id) {
      response = await ApiManager.request('ShopGroup').shopGroupEdit(shopGroup)
    } else {
      response = await ApiManager.request('ShopGroup').shopGroupAdd(shopGroup)
    }
    let type = 'success'
    if (response.data.code === Constants.ResponseCode.SUCCESS) {
    } else if (response.data.code === Constants.ResponseCode.VALIDATE_ERROR) {
      type = 'error'
    }
    commit('setMessage', { content: response.data.data.message, type: type })
    commit('setLoading', false)
  }
}

const mutations = {
  setLoading (state, data) {
    state.loading = data
    if (data) {
      this.dispatch('loading/loadingPagePlus')
    } else {
      this.dispatch('loading/loadingPageMinus')
    }
  },
  setShopGroup (state, data) {
    state.shop_group.id = data.data.id
    state.shop_group.name = data.data.name
    state.shop_group.tag = data.data.tag
    state.shop_group.publish_setting = data.data.publish_setting
    state.shop_group.details = data.details
  },
  setConstData (state, data) {
    Object.keys(state.constData).forEach(
      key => {
        if (key in data) {
          state.constData[key] = data[key]
        } else {
          state.constData[key] = []
        }
      }
    )
    if (!state.shop_group.shop_area_code && state.constData.shop_area.length) {
      state.shop_group.shop_area_code = state.constData.shop_area[0].code
    }
    //  カテゴリ階層算出
    let maxrank = Constants.getSite('shop_category_rank_qty')
    state.constData.shopCategoryLevel = maxrank - 0
    //  カテゴリ階層名
    state.customData.categoryRankName = Constants.getSite('shop_category_rank_name')
    if (!state.customData.categoryRankName) {
      state.customData.categoryRankName = [
        '',
        'カテゴリを選択',
        'カテゴリを選択',
        'カテゴリを選択',
        'カテゴリを選択',
        'カテゴリを選択',
        'カテゴリを選択',
        'カテゴリを選択',
        'カテゴリを選択',
        'カテゴリを選択',
        'カテゴリを選択'
      ]
    }
  },
  setIsSubmit (state, data) {
    state.isSubmit = data
  },
  setCondition (state, data) {
    state.shop_group.condition = data
  },
  setGroup (state, data) {
    state.shop_group.condition.group = data
    state.shop_group.condition.mode = 'group'
  },
  setCategory (state, data) {
    state.shop_group.condition.category = data
    state.shop_group.condition.mode = 'category'
  },
  setShopAreaCode (state, data) {
    state.shop_group.shop_area_code = data
  },
  setCode (state, data) {
    state.shop_group.condition.code = data
    state.shop_group.condition.mode = 'code'
  },
  setName (state, data) {
    state.shop_group.condition.name = data
    state.shop_group.condition.mode = 'name'
  },
  setFile (state, data) {
    state.shop_group.condition.file_name = data.file.name
    state.shop_group.condition.mode = 'file'
  },
  setFreeword (state, data) {
    state.shop_group.condition.freeword = data.freeword
  },
  clearCartItem (state, data) {
    state.shop_group.details = []
    state.isSubmit = false
  },
  setCartItem (state, data) {
    state.shop_group.details = data.data
  },
  addCartItem (state, data) {
    state.shop_group.details = _.unionBy(state.shop_group.details, data.data, 'shop_cd')
  },
  resetShopGroup (state, data) {
    const shopGroup = initialShopGroup()
    _.each(shopGroup, (value, key) => {
      state.shop_group[key] = value
    })
    state.isSubmit = false
  },
  setMessage (state, data) {
    state.message = data
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
